/* eslint-disable react-hooks/rules-of-hooks */
import React, {FC, useMemo, useState, useEffect} from "react";
import ReactDOMServer from "react-dom/server";

import { Avatar } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

import AppIcons from "./AppIcons.tsx";

import type {Tuser} from "../../types/easyTypes.ts";

type TchatRow = {
  user:string,
  strDate:string,
  text?:string,
  img?:string,
  file?:string
};

// {appkey, db, id, col}
type componentProps = {
  appkey:string,
  data?:Array<TchatRow>,
  maxrows?:number,
  allusers?:Array<Tuser>,
  color?:string,
  backgroundColor?:string,
  style?:React.CSSProperties | CSS.Properties,
  className?:string,
  gethtml?:boolean | "true" | "false"
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const {$, rz} = window;

const chatRenderer:FC<componentProps> = (props) => {
  // const customStyle = (props.style ? {...props.style} : undefined);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [theme, setTheme] = useState($("html").attr("data-theme"));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lng, setLng] = useState($("html").attr("lang"));
  const [errMsg, setErrMsg] = useState<string>("");

  const styl = useMemo<React.CSSProperties | CSS.Properties>(() => {
    const est:React.CSSProperties | CSS.Properties = {...props.style};
    let clr:string; const allc = (props.color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (props.backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [props, theme]);

  // Get all users
  const [allusers, setAllUsers] = useState<Array<Tuser>>([]);
  useEffect(() => {
    if (allusers.length || errMsg) { return }
    if (props.allusers) { setAllUsers(props.allusers); return }
    rz.serverAction({appkey: props.appkey, action: "loadAuxiliaryDBs", params: {dbs: ["users"]}}).then((ans) => {
      // @ts-ignore
      if (ans && ans.users && ans.users.length) { setAllUsers(ans.users) }
      else { setErrMsg(" ") }
    });
  }, [allusers.length, errMsg, props.allusers, props.appkey]);

  // Build array of Avatars
  const cellContent = useMemo(() => {
    if (!props.data || !rz.isArray(props.data) || !props.data.length) { return "" }
    const data1 = rz.objClone(props.data); data1.sort((a, b) => (a.strDate > b.strDate ? -1 : (a.strDate < b.strDate ? 1 : 0)));
    const data2 = (props.maxrows && rz.isNumber(props.maxrows) ? data1.filter((ii, i) => (i <= Number(props.maxrows))) : data1);
    return (
      data2.map((ii:TchatRow, i:number) => {
        // @ts-ignore
        const usr = (allusers.find((uu) => (uu.login.toLowerCase() === (ii.user || "").toLowerCase())) || {login: ii.user, name_ru: "", name_en: ""});

        return (
          <div key={"chat-row-" + (i + 1)} className={"uk-grid uk-grid-small"}>
            <div key={"chat-cell-1"} className={"uk-width-auto rz-margin-right-5"}>
              <Avatar key={"avatar"} size="default" shape="circle"
                src={"/ui/avatar/" + ii.user} icon={<AppIcons icopath="fa/FaUserSecret" attrs={{}} />}
                uk-tooltip={rz.strFromSelectedLng({lng: (lng as string), ru: (usr.name_ru as string), en: (usr.name_en as string), def: (usr.login as string)})}
              />
            </div>
            <div key={"chat-cell-2"} className={"uk-width-expand"}>
              {ii.text || ""}
            </div>
          </div>
        )
      })
    );
  }, [props.data, props.maxrows, allusers, lng]);

  // Return React.Element
  if (props?.getHTML || props?.gethtml === true || props?.gethtml === "true") {
    return ReactDOMServer.renderToStaticMarkup( // renderToString
      <div key={"chat-renderer"} id={"chat-renderer"} className={props.className} style={styl} >
        {cellContent}
      </div>
    );
  }

  return (
    <div
      key={"chat-renderer"} id={"chat-renderer"} className={props.className} style={styl} >
      {cellContent}
    </div>
  );
};

export default chatRenderer;
